module.exports = __webpack_public_path__ + "img/icon_1_26.04852a39.png";